import track from "@/components/monitoAction/track";
import Desensitize from "@/components/desensitize/desensitize";


const install = function (Vue) {
  Vue.directive('track', track)
  Vue.directive('desensitize', Desensitize)
}

if (window.Vue) {
  Vue.use(install);
}

export default install
